import { render, staticRenderFns } from "./DocumentUploadTray.vue?vue&type=template&id=ab03df5e&scoped=true"
import script from "./DocumentUploadTray.vue?vue&type=script&lang=js"
export * from "./DocumentUploadTray.vue?vue&type=script&lang=js"
import style0 from "./DocumentUploadTray.vue?vue&type=style&index=0&id=ab03df5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab03df5e",
  null
  
)

export default component.exports